import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import Search from '../components/Search.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const app = createApp({
            template: '<Search />',
            components: {
                Search
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}
